const MAX_CHART_IMAGE_RENDER_TIME = 30 * 1000;

export async function waitForChartImageToRender(chartImageElement: HTMLImageElement) {
  return new Promise<void>((resolve, reject) => {
    const startTime = Date.now();
    const intervalId = window.setInterval(() => {
      if (
        chartImageElement.complete &&
        chartImageElement.src &&
        chartImageElement.style.display !== 'none' &&
        chartImageElement.getBoundingClientRect().width > 0
      ) {
        window.clearInterval(intervalId);
        resolve();
        return;
      }

      if (Date.now() - startTime > MAX_CHART_IMAGE_RENDER_TIME) {
        window.clearInterval(intervalId);
        reject(new Error(`Chart image still not rendered after ${MAX_CHART_IMAGE_RENDER_TIME} milliseconds.`));
      }
    }, 100);
  });
}
